const STORAGE_KEY = 'tifosi_observation_private_flags';

interface LocalPrivateEntry {
  private: true;
  tifosi?: string;
}

function readMap(): Record<string, LocalPrivateEntry> {
  if (typeof localStorage === 'undefined') return {};
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    const out: Record<string, LocalPrivateEntry> = {};
    for (const [key, value] of Object.entries(parsed as Record<string, unknown>)) {
      const k = key.trim();
      if (!k) continue;
      if (value === true) {
        out[k] = { private: true };
        continue;
      }
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        const obj = value as Record<string, unknown>;
        if (obj.private === true || obj.isPrivate === true) {
          const tifosi = typeof obj.tifosi === 'string' ? obj.tifosi.trim() : undefined;
          out[k] = tifosi ? { private: true, tifosi } : { private: true };
        }
      }
    }
    return out;
  } catch {
    return {};
  }
}

function writeMap(map: Record<string, LocalPrivateEntry>): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* ignore quota / private mode */
  }
}

/** Persiste le mode privé côté appareil (secours si le champ GoPaaS `prive` est absent). */
export function setLocalObservationPrivate(
  cle: string | undefined | null,
  isPrivate: boolean,
  tifosiCle?: string | null,
): void {
  const key = (cle || '').trim();
  if (!key) return;
  const map = readMap();
  if (isPrivate) {
    const tifosi = (tifosiCle || '').trim();
    map[key] = tifosi ? { private: true, tifosi } : { private: true };
  } else {
    delete map[key];
  }
  writeMap(map);
}

export function getLocalObservationPrivate(cle: string | undefined | null): boolean {
  const key = (cle || '').trim();
  if (!key) return false;
  return Boolean(readMap()[key]);
}

export function getLocalObservationPrivateOwner(cle: string | undefined | null): string | undefined {
  const key = (cle || '').trim();
  if (!key) return undefined;
  return readMap()[key]?.tifosi;
}

/**
 * Fusionne le flag API avec le secours local.
 * - API true/false explicite → priorité API
 * - API absent (champ GoPaaS manquant) → secours localStorage
 */
export function resolveObservationPrivate(
  apiIsPrivate: boolean | undefined,
  cle: string | undefined | null,
): boolean {
  if (apiIsPrivate === true) return true;
  if (apiIsPrivate === false) return false;
  return getLocalObservationPrivate(cle);
}
